import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    description: 'Order Scan To Search Modal Header',
    defaultMessage: 'Barcode Scan Search',
    id: 'pvQavt',
  },
  searchOrderStatusLabel: {
    description: 'Order Scan To Search, Search Order Status Label',
    defaultMessage: 'Search for orders in status:',
    id: 'Js/1CF',
  },
  whenOrderFoundLabel: {
    description: 'Order Scan To Search, When orders found Label',
    defaultMessage: 'When orders are found:',
    id: '9Xq2Qp',
  },
  keepWindowOpenLabel: {
    description: 'Order Scan To Search, Keep window open Label',
    defaultMessage: 'Always keep window open',
    id: '6Q2EEY',
  },
  'awaiting-payment': {
    description: 'Order Status Awaiting Payment',
    defaultMessage: 'Awaiting Payment',
    id: 'GvBhyF',
  },
  'awaiting-shipment': {
    description: 'Order Status Awaiting Shipment',
    defaultMessage: 'Awaiting Shipment',
    id: 'WTAhVF',
  },
  'rejected-fulfillment': {
    description: 'Fulfillment Was Rejected',
    defaultMessage: 'Rejected Fulfillment',
    id: 'IAca3v',
  },
  'on-hold': {
    description: 'Order Status On Hold',
    defaultMessage: 'On Hold',
    id: 'ABoqj7',
  },
  shipped: {
    description: 'Order Status Shipped',
    defaultMessage: 'Shipped',
    id: 'N8kE9h',
  },
  cancelled: {
    description: 'Order Status Cancelled',
    defaultMessage: 'Cancelled',
    id: 'QsxZar',
  },
  display: {
    description: 'Display orders after find',
    defaultMessage: 'Just display the order(s)',
    id: 'XqRpVH',
  },
  ship: {
    description: 'Ship orders after find',
    defaultMessage: 'Ship the order(s)',
    id: 'nEliBc',
  },
  addNewBatch: {
    description: 'Add New Batch orders after find',
    defaultMessage: 'Add order(s) to a new batch',
    id: 'avaDsj',
  },
  addExistingBatch: {
    description: 'Add Existing Batch orders after find',
    defaultMessage: 'Add order(s) to existing batch',
    id: 'tA+DSx',
  },
  batchNamePlaceholder: {
    description: 'Placeholder for batch name if the user has no batches',
    defaultMessage: 'No available batches',
    id: 'xsFJtY',
  },
  searchFailedTitle: {
    description: 'Title for the notification of an unsuccessful search',
    defaultMessage: 'Orders Search',
    id: 'mYEr21',
  },
  searchFailedContent: {
    description: 'Content for the notification of an unsuccessful search',
    defaultMessage: 'Your barcode search returned no results.',
    id: '4DYoAd',
  },
});
